export default __webpack_public_path__ + "static/header-arrow-9047bedf90c111537694badc382c1634.svg";